// Central mapping for data-testid values used across the app.
export const TESTIDS = {
  // Layout
  header: "site-header",
  logo: "site-logo",
  navHome: "nav-home",
  navServices: "nav-services",
  navAbout: "nav-about",
  navBlog: "nav-blog",
  navContact: "nav-contact",
  ctaWhatsAppHeader: "cta-whatsapp-header",
  ctaWhatsAppFab: "whatsapp-fab",
  footer: "site-footer",
  mobileMenuToggle: "mobile-menu-toggle",

  // Home
  homeHero: "home-hero",
  homeHeroCta: "home-hero-cta-whatsapp",
  homeServicesGrid: "home-services-grid",
  homeFeaturedBlog: "home-featured-blog",

  // Contact
  contactForm: "contact-form",
  contactName: "contact-input-name",
  contactEmail: "contact-input-email",
  contactPhone: "contact-input-phone",
  contactPet: "contact-input-pet",
  contactExam: "contact-select-exam",
  contactMessage: "contact-textarea-message",
  contactSubmit: "contact-submit-button",

  // Blog
  blogList: "blog-list",
  blogCard: "blog-card",
  blogPost: "blog-post-article",

  // Admin
  adminLoginForm: "admin-login-form",
  adminLoginEmail: "admin-login-email",
  adminLoginPassword: "admin-login-password",
  adminLoginSubmit: "admin-login-submit",
  adminDashboard: "admin-dashboard",
  adminNewPost: "admin-new-post-button",
  adminSavePost: "admin-save-post-button",
  adminLogout: "admin-logout-button",
};
